<div *ngIf="LoaderComponent.isLoading"
    class="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-25 flex items-center justify-center z-[999999999999]">
    <div class="loader">
        <!-- <img  class="h-32 w-32" src="https://www.ifood.it/wp-content/uploads/2023/11/giorgione.jpg"> Rimpiazzare con questo in caso di immagine o svg -->
    </div>
</div>